<template>
    <div style="position: relative;">
        <div class="new-main">
            <div class="edit-plan-detail">
                <div class="plan-head">
                    <i class="fa fa-calendar" style="font-size: 24px;"></i>
                    <div>
                        <p class="font-16" style="margin-bottom: 5px;">
                            {{planData.title}}
                        </p>
                        <p class="text-l-gray" style="font-size: 12px;margin-top: 0;">

                            <span class="name-info font12" v-if="planData.plan_type=='week'"> 周计划</span>
                            <span class="name-info font12" v-if="planData.plan_type=='month'">月计划</span>
                            <span class="name-info font12" v-if="planData.plan_type=='quarter'"> 季度计划</span>
                            <span class="name-info font12" v-if="planData.plan_type=='custom'"> 自定义计划</span>
                            <span class="font12" style="margin-left: 10px">
                                时间：{{planData.open_time}}-{{planData.end_time}}
                            </span>
                            <span class="font12" style="margin-left: 15px;">
                                发布：{{planData.publish_time}}
                            </span>
                        </p>
                    </div>
                </div>
                <div class="plan-body" style="min-height: 534px;">
                    <table>
                        <tbody>
                        <tr>
                            <td class="wth30 v-top"><i class="fa fa-file"></i></td>
                            <td>
                                <!-- 内容 -->
                                <table class="text-m-gray table-content">
                                    <tbody>
                                    <tr>
                                        <td class="bold first v-top"><span class="bold mheight38">内容：</span></td>
                                        <td>
                                            <div class="vertical-top">
                                                <div class="text-h-gray bold  plan-title  ">
                                                    <b>{{planData.content}}</b></div>
                                                <ul class="text-m-gray color333 plan-content">
                                                    <li class="detail-item clearfix"
                                                        v-for="(detail,index) in planData.details_info"
                                                        :key="index">
                                                        <div class="detail-item-content-wrap" id="detailEditTip">
                                                            <div class="circle-progress"
                                                                 style="float: left;cursor: pointer;">
                                                                <div class="num">
                                                                    <div class="circle_Percent"
                                                                         style="position: relative"
                                                                         @click="updateProgress(detail)">
                                                                        <div class="circleProgress">
                                                                            <div :class="classObject(detail.rate_of_progress)">
                                                                                <div class="circleLeft"></div>
                                                                                <div class="circleRight"></div>
                                                                                <div class="progressNum">
                                                                                    <span style="font-size: 7px;">   {{detail.rate_of_progress}}</span>

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="break-all detail-item-content">
                                                                <div style="float: left;width: 100%;">
                                                                    {{detail.details}}
                                                                </div>
                                                                <div style="float: left;width:100%;font-size: 12px;">
                                                                    <span class="name-info font12 text-l-gray"
                                                                          v-if="detail.isImportant">重要</span>
                                                                    <i class="font12 fa fa-check"
                                                                       v-if="detail.isImportant"
                                                                       style="margin-left: 5px;color: darkgreen;"></i>
                                                                    <span class="name-info font12 text-l-gray"
                                                                          v-if="detail.isEmergency"
                                                                          style="margin-left: 5px;">紧急</span>
                                                                    <i class="font12 fa fa-check"
                                                                       v-if="detail.isEmergency"
                                                                       style="margin-left: 5px;color: darkgreen;"></i>
                                                                    <span class="font12 text-l-gray">
                                                                        {{detail.start_time}} - {{detail.end_time}}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <!-- 总结 -->
                                <table class="text-m-gray conclusion break-all">
                                    <tbody>
                                    <tr>
                                        <td class="bold first v-top">
                                            总结：
                                        </td>
                                        <td class="second" style="position: relative;">
                                            <div class="vertical-top color333" v-html="planData.summary"></div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>
                        <tr>
                            <td class="v-top"><i class="icon-comment mar-tr-4"></i></td>
                        </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    export default {
        name: "view_plan",
        props: {
            plan_Type: {
                default: null,
                type: String
            },
            planData: {
                default: null,
                type: Object
            }
        },
        data: function () {
            return {}
        },
        components: {},
        computed: {},
        methods: {
            classObject: function (rate) {
                if (rate == 25) return 'circle25'
                if (rate == 50) return 'circle50'
                if (rate == 75) return 'circle75'
                if (rate == 100) return 'circle100'
            },
        },
        mounted: function () {
        }
    }
</script>

<style scoped>
    .top-bar {
        position: relative;
        padding: 10px 20px;
        overflow: hidden;
        background-color: #fff;
    }

    .top-bar .left {
        font-weight: normal;
        float: left;
    }

    .top-bar button {
        height: 28px;
        background-color: #fff;
        border: 1px solid #d7d8d9;
    }

    .margin-right-a10 {
        margin-right: 10px;
    }

    .width73 {
        width: 73px !important;
    }

    button, a.btn {
        border-radius: 2px;
        border-style: none;
    }


    .edit-plan-detail .plan-head {
        height: 59px;
        padding: 0 20px;
        background-color: #f8f8f8;
        border-bottom: 1px solid #e6e6e6;
    }

    .edit-plan-detail .plan-head div p {
        margin-top: -4px;
    }

    .edit-plan-detail .plan-head div {
        display: inline-block;
        margin: 14px 0px 14px 8px;
    }

    .edit-plan-detail .plan-head > div {
        float: left;
    }

    .edit-plan-detail .plan-head > i {
        float: left;
        margin-top: 16px;
    }

    .font-16 {
        font-size: 16px;
    }

    .text-l-gray {
        color: #999;
    }

    .edit-plan-detail .plan-body {
        padding: 25px 0 0px 30px;
        background-color: #fff;
    }

    .edit-plan-detail .plan-body table {
        width: 100%;
    }

    .edit-plan-detail .plan-body table tr td.wth30 {
        width: 30px;
    }

    .edit-plan-detail .plan-body .v-top {
        vertical-align: top;
    }

    .text-m-gray {
        color: #666;
    }

    .edit-plan-detail .plan-body table tr td .first {
        width: 40px;
    }

    .bold {
        font-weight: bold !important;
    }

    .edit-plan-detail .plan-body table tr td .mheight38 {
        min-height: 38px;
    }

    .edit-plan-detail .plan-body table tr td .plan-title {
        margin-bottom: 3px;
    }

    .text-h-gray {
        color: #333;
    }

    .edit-plan-detail .plan-body table tr td ul.plan-content {
        color: #666;
        min-height: 39px;
        margin: 0;
    }

    .color333 {
        color: #333 !important;
    }

    .edit-plan-detail .plan-body table tr td ul.plan-content li.detail-item {
        position: relative;
        list-style: none;
        padding: 10px 30px 10px 5px;
        border-bottom: 1px solid #ededed;
    }

    .clearfix:before, .clearfix:after {
        display: table;
        content: "";
        line-height: 0;
    }

    .edit-plan-detail .plan-body table tr td ul.plan-content li.detail-item > div {
        float: left;
    }

    .edit-plan-detail .plan-body table tr td ul.plan-content li.detail-item .detail-item-content-wrap {
        width: 100%;
    }

    .edit-plan-detail .plan-body table tr td ul.plan-content li.detail-item .detail-item-content-wrap .detail-item-content {
        margin-left: 40px;
    }

    .break-all {
        word-break: break-all;
    }

    .clearfix:after {
        clear: both;
    }

    .edit-plan-detail .plan-body table tr td .conclusion .first {
        vertical-align: middle;
    }

    .edit-plan-detail .plan-body table tr td .conclusion {
        margin-bottom: 32px;
        border-bottom: 1px solid #dedede;
        border-top: 1px solid #dedede;
    }

    .edit-plan-detail .plan-body table tr td .conclusion .second {
        padding: 32px 30px 26px 0;
    }

    .edit-plan-detail .plan-body table tr td .conclusion .first.padding-top20 {
        padding-top: 20px;
    }


    .circle-progress {

        position: relative;

    }


    .circleProgress {
        width: 2em;
        height: 2em;
        position: relative;
    }

    .circleProgress .progressNum {
        position: absolute;
        width: 1.5em;
        height: 1.5em;
        background-color: white;
        border-radius: 50%;
        left: 0.25em;
        top: 0.25em;
        line-height: 1.5em;
        text-align: center;
    }

    .circleLeft,
    .circleRight {
        width: 1em;
        height: 2em;
        overflow: hidden;
        position: relative;
        float: left;
        background-color: #2980b9;

    }

    .circleLeft {
        border-radius: 2em 0 0 2em;
    }

    .circleRight {
        border-radius: 0 2em 2em 0;
    }

    .circleLeft:after,
    .circleRight:after {
        content: "";
        position: absolute;
        display: block;
        width: 1em;
        height: 2em;
        background-color: white;
        border-radius: 2em 0 0 2em;
        background-color: #f2f2f2;
    }

    .circleRight:after {
        content: "";
        position: absolute;
        display: block;
        border-radius: 0 2em 2em 0;
    }

    .circle25 .circleLeft:after {
        transform-origin: right center;
    }

    .circle25 .circleRight:after {
        transform-origin: left center;
        transform: rotateZ(90deg);
    }

    .circle50 .circleLeft:after {
        transform-origin: right center;
    }

    .circle50 .circleRight:after {
        transform-origin: left center;
        transform: rotateZ(180deg);
    }

    .circle75 .circleLeft:after {
        transform-origin: right center;
        transform: rotateZ(90deg);
    }

    .circle75 .circleRight:after {
        transform-origin: left center;
        transform: rotateZ(180deg);
    }

    .circle100 .circleLeft:after {
        transform-origin: right center;
        transform: rotateZ(180deg);
    }

    .circle100 .circleRight:after {
        transform-origin: left center;
        transform: rotateZ(180deg);
    }

    .num {
        position: absolute;
        text-align: center;
        font-weight: bold;
        top: 7px;
        left: 7px;
    }

    .progressImg {
        width: 26px;
        height: 26px;
    }
</style>
